(function($, SU) {
    $.fn.expander = function() {
        var $expanders = this;

        function scrollToExpander($expander) {
            $('html,body').animate({ scrollTop: $expander.offset().top - 80 }, 'fast');
        }

        $(window).on('hashchange', function(event) {
            event.preventDefault();
            $expanders.each(function() {
                var $expander = $(this),
                    id = this.id,
                    state = $.bbq.getState(id);

                if (state === 'is-expanded') {
                    $expander.addClass('is-expanded').removeClass('is-collapsed');
                    $expander.find('a').attr('aria-expanded', 'true');
                } else {
                    $expander.removeClass('is-expanded');
                    $expander.find('a').attr('aria-expanded', 'false');
                }
            });
        });

        $expanders.each(function() {
            var $expander = $(this);

            $expander.find('.expander-click-target').eq(0).on('click', function(e) {
                var state = $.bbq.getState(),
                    id = $expander.attr('id');

                e.preventDefault();
                $expander.toggleClass('is-collapsed is-expanded');

                if ($expander.hasClass('is-expanded')) {
                    state[id] = 'is-expanded';
                    delete state.bbq;
                    $.bbq.pushState(state, 2);
                } else {
                    delete state[id];
                    if (Object.keys(state).length === 0) {
                        // dummy value, which prevents browser scrolling to top when hash is just #
                        state.bbq = 'on';
                    }
                    $.bbq.pushState(state, 2);
                }

                scrollToExpander($expander);

                return false;
            });
        });

        SU.injectedScripts.push(function($) {
            if ($expanders.length >= 1) {
                $(window).trigger('hashchange');

                const $openExpanders = $expanders.filter('.is-expanded');
                if ($openExpanders.length >= 1) {
                    scrollToExpander($openExpanders.eq(0));
                }
            }
        });

        return this;
    };
}(jQuery, SU));
